import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import AppModal from "../common/AppModal";
import ShiftBreakdown from "./ShiftBreakdown";
import DetailItem from "../common/DetailItem";
import AppCircularProgress from "../common/AppCircularProgress";
import { ShiftResponseDto } from "../../shared/dtos/shift/ShiftResponseDto";
import { formatPlainNumber } from "../../utils/appUtils";

interface ViewShiftModalProps {
  open: boolean;
  onClose: () => void;
  shift: ShiftResponseDto | null;
  loading: boolean;
  error?: string | null;
}

const ViewShiftModal: React.FC<ViewShiftModalProps> = ({
  open,
  onClose,
  shift,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Historical Shift Details"
    width="md"
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    {loading ? (
      <AppCircularProgress />
    ) : shift ? (
      <Box>
        <ShiftBreakdown shift={shift} />
        {!shift.isOpen &&
          shift.cashDiscrepancy !== undefined &&
          shift.declaredCash !== undefined && (
            <Box
              sx={{
                mt: 3,
                p: 2,
                bgcolor: "background.default",
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Typography
                variant="overline"
                sx={{ color: "text.secondary", mb: 1, display: "block" }}
              >
                Reconciliation Results
              </Typography>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <DetailItem
                  label="Declared Cash"
                  value={formatPlainNumber(shift.declaredCash)}
                />
                <DetailItem
                  label="Discrepancy"
                  value={
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color:
                          shift.cashDiscrepancy < 0
                            ? "error.main"
                            : shift.cashDiscrepancy > 0
                              ? "warning.main"
                              : "success.main",
                      }}
                    >
                      {formatPlainNumber(shift.cashDiscrepancy)}
                    </Typography>
                  }
                />
              </Box>
            </Box>
          )}
      </Box>
    ) : null}
  </AppModal>
);

export default ViewShiftModal;
